const hostname = window.location.hostname;

export const isProduction = hostname === 'webservices-portal.web.cern.ch';
export const isDev =
  hostname.includes('webservices-portal-dev.web.cern.ch') || hostname.includes('localhost');
export const isStaging = hostname.includes('webservices-portal-staging.web.cern.ch');
